<template>
	<modal width="40" :show-modal="showModal" @close-modal="$emit('close-modal')" :styleContent="{ minWidth: '400px' }"
		:showTitle="false" :showCancleBtn="true" :showFooter="false">
		<div class="w-full">
            <h2 class="text-center font-bold text-[#10233E] text-[16px]" >KYC Submitted Successfully</h2> 
            <div class="flex justify-center mt-4 mb-4 w-full "><img width="70" src="@/assets/images/icons/success_icon.svg" @click="goBack"></div>  
            <p >Your KYC has been submitted for verification.</p>
            <p >You can expect feedback within 24–72 hours.</p>
            <button  class="py-2 px-4    w-full"  @click="handleCloseSuccessModal">Ok</button>	
            <!-- <button  class="py-2 px-4    w-full"  @click="$emit('close-modal')">Ok</button>	 -->
		</div>
	</modal>
</template>

<script>

export default {

	props: {	
		showModal: {
			type: Boolean,
			required: true,
			default: false,
		},
		
	},
	data() {
		return {
			
		}
	},
	methods: {
		handleCloseSuccessModal() {
			// this.showSuccessModal = false;
			this.$router.push({ name: "3plDashboard" });

		},
		
		// closeModal() {
		// 	this.$emit("close-modal");
		// },
	
	}

};

</script>

<style scoped>
button {
    background-color: #FCC210;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin: 10px auto; 
} 
 
p{
    color: #383F51;
    font-size: 14px;
    text-align: center;
    margin-bottom: 10px; 
}
</style>